// @flow

import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';

import { needsAuth } from '@gandi/authentication';
import { withTranslator } from '@gandi/translate';

import { Layout } from '../../components/Layout';
import { withRouter } from '../../helpers/withRouter';

import Presenter from './Presenter';
import type { Props } from './Presenter';

export function DecorateContent(props: Props): React.MixedElement {
  return (
    <Layout showCartSummary currentStep={1}>
      <Presenter {...props} />
    </Layout>
  );
}

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  needsAuth,
  // For prefetch
  withRouter,
  withPageMeta(args => ({
    title: args.__('Choose billing and ownership information - Gandi.net'),
  })),
)(DecorateContent): React.ComponentType<{}>);
